function updateArrow(inputId, barId, arrowId) {
  const input = document.getElementById(inputId);
  const bar = document.getElementById(barId);
  const arrow = document.getElementById(arrowId);

  if (!input || !bar || !arrow) return;

  const value = parseFloat(input.value) || 0;
  const max = parseFloat(input.max) || 100;

  const percent = Math.min(100, Math.max(0, value / max));
  const width = bar.clientWidth;

  const px = percent * width;
  $('#' + arrowId).css('left', px + 'px');
}

  $(document).ready(function () {
    updateArrow('rueckenlaenge', 'bar-rueckenlaenge', 'arrow-rueckenlaenge');
    updateArrow('brustumfang', 'bar-brustumfang', 'arrow-brustumfang');
    updateArrow('halsumfang', 'bar-halsumfang', 'arrow-halsumfang');

    $('#rueckenlaenge').on('input', function () {
      updateArrow('rueckenlaenge', 'bar-rueckenlaenge', 'arrow-rueckenlaenge');
    });
    $('#brustumfang').on('input', function () {
      updateArrow('brustumfang', 'bar-brustumfang', 'arrow-brustumfang');
    });
    $('#halsumfang').on('input', function () {
      updateArrow('halsumfang', 'bar-halsumfang', 'arrow-halsumfang');
    });
  });
